import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import { SortableDevices } from 'console/shared/components/features/sortable-devices';
import { useSkeleton } from 'console/shared/features/skeleton/hook';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { DashboardDeviceView } from './device';
import { DashboardDeviceContentProvider } from '../../provider/device';
import { useDashboard } from '../../provider';
import { DashboardStub } from 'console/stubs/dashboard';
import { useDashboardControl } from '../../provider/control';
import { WrapButton } from 'console/shared/components/buttons/wrap';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
const wrap_button_sx = {
    justifyContent: 'center',
    p: 1,
};
export const DashboardDevices = memo(function DashboardDevices() {
    const { devices_ids, sorting_mode } = useDashboard();
    const { is_devices_wrapped, toggleDevicesWrap } = useDashboardControl();
    const Skeleton = useSkeleton(DefaultTabKey.dashboard);
    const component = useCallback((device_id) => {
        return (_jsx(DashboardDeviceContentProvider, { device_id: device_id, children: _jsx(DashboardDeviceView, {}, `${device_id}-${sorting_mode}`) }));
    }, [sorting_mode]);
    const devices = useMemo(() => devices_ids.map((id) => ({ id: id })), [devices_ids]);
    if (devices.length === 0) {
        return _jsx(DashboardStub, {});
    }
    return (_jsxs(Box, { overflow: "hidden", height: "100%", children: [sorting_mode && isSmallUI() && (_jsx(WrapButton, { is_wrapped: is_devices_wrapped, onClick: toggleDevicesWrap, word: "\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430", sx: wrap_button_sx, fullWidth: true })), _jsx(Skeleton, { children: _jsx(Box, { width: "100%", height: "100%", overflow: "auto", children: _jsx(SortableDevices, { component: component, devices: devices }) }) })] }));
});
